import './App.css';
import Todos from './components/Todos/Todos';

function App() {
  return (
    <div className="App">
      <h1>React Redux API Data Fetching</h1>
      <Todos/>
    </div>
  );
}

export default App;
